import '../styles/components/PDFLoading.css'

export const PDFLoading = () => {
  return (
    <div className='pdf-loading'>
        <div className="spinner-border text-info" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
  )
}
